import BaseService from './baseService';
import { UserSettings } from 'store/accountMgmt/types';

export default class UserSettingsService extends BaseService {
    constructor() {
        super('userSettings');
    }

    /**
     * Gets settings for selected user.
     * @param {string} userId - user uid
     * @returns object with settings
     */
    getSettings = (userId: string) => this.httpGetRequest(`${userId}/list`);

    /**
     * Updates selected user
     * @param {string} userId - user uid
     * @param {Object} settings - settings object for selected user
     * @param {number | null} setting.maxSegmentsPerRun
     * @param {string | null} setting.removeCubeLocksTimeUtc
     * @returns void
     */
    updateSettings = (userId: string, settings: UserSettings) => this.httpPutRequest(`${userId}/update`, settings);

}